import React, { Component } from 'react';
import pubsub from 'pubsub-js';
import { Translate, Localize } from 'react-redux-i18n';
import {
    NavDropdown, MenuItem, Grid, Row, Col, Panel, Button, Tabs, Tab,
    ButtonToolbar, Breadcrumb, Input, Dropdown
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { SkyLightStateless } from 'react-skylight';

import HeaderRun from './Header.run'
import Modals from './baseModals';
import checkPermission from '../Common/permissions';
import { signoutUser } from '../../actions/auth_actions';
import { getCompanies, setSelectedCompany, setSelectedWarehouse, getLocalStorageData } from '../../reducers/headerRedux';
import CustomDropdown from "../Common/customDropdown";
import UserPassword from '../../containers/Auth/userPassword';
// import { fetchWarehouses } from '../../actions/warehouses_actions';
import { changeToChinese, changeToEnglish } from '../../actions/language_actions';
import {
  ROOT_URL, ROOT_API_URL, isABBLE, isGGI, isHO, isJRC, isGFD, isSUN, isABCFF, isVAK, 
  isOCM, isSH
 } from '../../actions/root_url';
import { isAllCompaniesWhiteList, isProductPage } from '../../utils/index';

const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';
const isHF = ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || ROOT_URL === 'https://hfstage-erp.truckxi.com/api/';

//import {logoStyle, logo1Style} from '../Common/style';

class Header extends Component {
  constructor() {
    super();
    this.state = {
      confirmRefreshOpen: false,
      warehouseLocationDisplay: null,
      warehouseLocation: null,
      warehouseLocationSelection: [],

      companyLocationDisplay: null,
      companyLocation: null,
      companyLocationSelection: [],
      editPasswordOpen: false,
    };
    this.pageRefreshOpen = this.pageRefreshOpen.bind(this);
    this.pageRefreshClose = this.pageRefreshClose.bind(this);
    this.openEditPassword = this.openEditPassword.bind(this);
    this.closeEditPassword = this.closeEditPassword.bind(this);
  }

    componentDidMount() {
      HeaderRun();
      this.props.getCompanies();
      if (isOCM) {
        if (localStorage.getItem('is_first_login')==='true') {
          this.setState({editPasswordOpen: true});
        } else {
          this.setState({editPasswordOpen: false});
        }
      }
      // this.props.fetchWarehouses();
    }

    componentDidUpdate(prevProps) {
      if (!_.isEqual(prevProps.companySelection, this.props.companySelection)) {
        this.props.setSelectedCompany(this.props.selectedCompany || this.props.companySelection[0]);
      }
      if (!_.isEqual(prevProps.warehouseSelection, this.props.warehouseSelection) && this.props.warehouseSelection.length) {
        const defaultWarehouse = _.filter(this.props.warehouseSelection, warehouse => warehouse.isDefault);
        const selectedWarehouseLocalStorage = getLocalStorageData('selectedWarehouse');
        let selectedWarehouse;

        if (selectedWarehouseLocalStorage) {
          const selectedWarehouseFound = _.filter(this.props.warehouseSelection, warehouse => warehouse.value === selectedWarehouseLocalStorage.value);
          if (selectedWarehouseFound[0]) {
            selectedWarehouse = selectedWarehouseFound[0];
          }
        }
        if (!selectedWarehouse) {
          selectedWarehouse = defaultWarehouse[0];
        }
        if (!selectedWarehouse) {
          selectedWarehouse =  this.props.warehouseSelection[0];
        }
        if ((isSUN || isVAK) && this.props.warehouseSelection && this.props.warehouseSelection.length >1) {
          this.props.setSelectedWarehouse(this.props.warehouseSelection[1]);
        } else {
          this.props.setSelectedWarehouse(selectedWarehouse);          
        }
      }
    }
    
    componentWillReceiveProps(nextProps) {
      if(isGGI && !isAllCompaniesWhiteList(window.location.href) && nextProps.selectedCompany && nextProps.selectedCompany.value == 0 && this.props.companySelection && this.props.companySelection.length > 0 && this.props.companySelection[0]) {
        this.props.setSelectedCompany(this.props.companySelection[0])
      }
      if (isVAK && nextProps.selectedCompany && nextProps.selectedCompany !== this.props.selectedCompany) {
        if (nextProps.selectedCompany.value !== 1 && (location.pathname === '/MFG' || location.pathname === '/outsourced' || location.pathname === '/BOM')) {
          location.href = `https://vakker-scm.truckxi.com/MR`
        }
        if (nextProps.selectedCompany.value !== 6 && location.pathname === '/pickingList') {
          location.href = `https://vakker-scm.truckxi.com/mobileSalesOrders`
        }
        if (nextProps.selectedCompany.value !== 6 && location.pathname === '/productMapping') {
          location.href = `https://vakker-scm.truckxi.com/products`
        }
      }
    }

    toggleUserblock(e) {
      e.preventDefault();
      pubsub.publish('toggleUserblock');
    }

    logOut() {
      this.props.signoutUser();
    }
    
    openEditPassword() {
      // this.props.resetPassword();
      this.setState({editPasswordOpen: true});
    }

    closeEditPassword() {
      this.setState({editPasswordOpen: false});
    }
    
    pageRefreshOpen() {
      this.setState({ confirmRefreshOpen: true });
    }
    pageRefreshClose() {
      this.setState({ confirmRefreshOpen: false });
    }
    pageRefreshConfirm() {
      this.setState({ confirmRefreshOpen: false });
      setTimeout(function () {
          window.location.reload(true);
      }, 2000);
      window.location.pathname = `/`;
    }

    handleCompanyChange = (e, selectedCompany) => {
      this.props.setSelectedCompany(selectedCompany);
    }

    handleWarehouseChange = (e, selectedWarehouse) => {
      if (this.checkWarehouseDisable(selectedWarehouse.value)) {
        return;
      }
      this.props.setSelectedWarehouse(selectedWarehouse)
    }

    checkWarehouseDisable = (value) => {
      const location = this.props.location;
      if (isVAK && value === '0') {
        return true;
      }
      if (location.pathname.includes('/products/') && value === '0') {
        return true;
      }
      return false;
    }

    render() {
      let {
        warehouseLocation, warehouseLocationDisplay, warehouseLocationSelection,
        companyLocation, companyLocationDisplay, companyLocationSelection,
      } = this.state;
      const {
        companySelection,
        selectedCompany,
        warehouseSelection,
        selectedWarehouse,
        userDetail,
      } = this.props;
                
      if (isAFM) {
        if (warehouseLocationSelection.length < 1) {
          if (checkPermission('view_belongwarehouse_All')) {
            warehouseLocationSelection.push(
              {
                label: <Translate value="all_locations" />,
                value: '',
              },
              {
                label: "Beaverton",
                value: 'Beaverton',
              },
              {
                label: "Bellevue",
                value: 'Bellevue',
              },
              {
                label: "Seattle",
                value: 'Seattle',
              },
            );
            this.setState({ warehouseLocationSelection });
          } else if (checkPermission('view_belongwarehouse_Beaverton')) {
            warehouseLocationSelection.push(
              {
                label: "Beaverton",
                value: 'Beaverton',
              },
            );
            this.setState({ warehouseLocationSelection });
          } else if (checkPermission('view_belongwarehouse_Bellevue')) {
            warehouseLocationSelection.push(
              {
                label: "Bellevue",
                value: 'Bellevue',
              },
            );
            this.setState({ warehouseLocationSelection });
          } else if (checkPermission('view_belongwarehouse_Seattle')) {
            warehouseLocationSelection.push(
              {
                label: "Seattle",
                value: 'Seattle',
              },
            );
            this.setState({ warehouseLocationSelection });
          }
        }
        if (localStorage.getItem('warehouseLocation') === '' || !localStorage.getItem('warehouseLocation')) {
          warehouseLocation = '';
          warehouseLocationDisplay = <Translate value="all_locations" />;
        } else if (localStorage.getItem('warehouseLocation') === 'Beaverton') {
          warehouseLocation = 'Beaverton';
          warehouseLocationDisplay = 'Beaverton';
        } else if (localStorage.getItem('warehouseLocation') === 'Bellevue') {
          warehouseLocation = 'Bellevue';
          warehouseLocationDisplay = 'Bellevue';
        } else if (localStorage.getItem('warehouseLocation') === 'Seattle') {
          warehouseLocation = 'Seattle';
          warehouseLocationDisplay = 'Seattle';
        }
      }

      const handleWarehouseLocationChange = (el) => {
        let { warehouseLocationDisplay, warehouseLocation } = this.state;
        warehouseLocationDisplay = el.label;
        warehouseLocation = el.value;
        localStorage.setItem('warehouseLocation', warehouseLocation);
        this.setState({ warehouseLocationDisplay, warehouseLocation });
        window.location.reload();
        // window.location.pathname = `/`;
      }

      const ddAlertTitle = (
        <span><em className="fa fa-gear"></em></span>
      )
      const langIcon = (
        <span><em className="fa fa-language"></em></span>
      )
      const refreshDialogueStyle = {
        width: '450px',
        height: '200px',
        marginLeft: '-10%'
      }
      const refresh_system = (<Translate value="refresh_system" />);
      const changePassword = (<Translate value="change_password" />);
        
      let createDialogStyle = {
        height: '300px',
        width: '600px',
        marginLeft: '-10%',
      };
      let username = localStorage.getItem('username');
      if (username) {
        username = `(${username})`
      }
      return (
        <header className="topnavbar-wrapper">
          { /* START Top Navbar */}
          <nav role="navigation" className="navbar topnavbar">
            { /* START navbar header */}
            <div className="navbar-header">
              <a className="navbar-brand">
                <div className="brand-logo text-center">
                  {!isHF && <label>SCM{username}</label>}
                  {isHF && <label>ERP</label>}
                </div>
                <div className="brand-logo-collapsed">
                  <img src="/img/logo1.png" alt="App Logo" className="img-responsive logo1Style" />
                </div>
              </a>
            </div>
            { /* END navbar header */}
            { /* START Nav wrapper */}
            <div className="nav-wrapper">
              { /* START Left navbar */}
              <ul className="nav navbar-nav">
                <li>
                  { /* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
                  <a href="#" data-trigger-resize="" data-toggle-state="aside-collapsed" className="hidden-xs">
                    <em className="fa fa-navicon"></em>
                  </a>
                  { /* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
                  <a href="#" data-toggle-state="aside-toggled" data-no-persist="true" className="visible-xs sidebar-toggle">
                    <em className="fa fa-navicon"></em>
                  </a>
                </li>
                  { /* START User avatar toggle
                  <li>
                      Button used to collapse the left sidebar. Only visible on tablet and desktops
                      <a id="user-block-toggle" href="#" onClick={ this.toggleUserblock }>
                          <em className="fa fa-user"></em>
                      </a>
                  </li>
                    END User avatar toggle */}
              </ul>
              { /* END Left navbar */}
              { /* START Right Navbar */}
              <ul className="nav navbar-nav navbar-right">
                {/* {
                    isAFM &&
                    <li style={{ padding: '11px' }}>
                        <Dropdown>
                            <Dropdown.Toggle style={{ width: '120px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                                {warehouseLocationDisplay}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="super-colors">
                                {warehouseLocationSelection.map(el => {
                                    return (
                                        <MenuItem onClick={() => handleWarehouseLocationChange(el)}>{el.label}</MenuItem>
                                    )
                                })}
                            </Dropdown.Menu>
                        </Dropdown>
                    </li>
                } */}
                <li style={{ padding: '11px' }}>
                  <Dropdown>
                    <Dropdown.Toggle style={{ width: '180px', overflow: 'hidden', textOverflow: 'ellipsis', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                      {selectedCompany && selectedCompany.label}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="super-colors">
                      {companySelection.map(el => {
                        return (
                          <MenuItem onClick={(e) => this.handleCompanyChange(e, el)}>{el.label}</MenuItem>
                        )
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                <li style={{ padding: '11px' }}>
                  <Dropdown>
                    <Dropdown.Toggle style={{ width: '180px', overflow: 'hidden', textOverflow: 'ellipsis', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                      {selectedWarehouse && selectedWarehouse.label}
                    </Dropdown.Toggle>
                    <CustomDropdown.Menu id="navbar-dropdown" bsRole="menu">
                      {warehouseSelection.map(el => {
                        return (
                            <MenuItem disabled={this.checkWarehouseDisable(el.value)} onClick={(e) => this.handleWarehouseChange(e, el)}>{el.label}</MenuItem>
                        )
                      })}
                    </CustomDropdown.Menu>
                  </Dropdown>
                </li>
                <li>
                  <a onClick={this.pageRefreshOpen}>
                    <em className='fa fa-refresh' />
                  </a>
                </li>
                { /* START Language Menu */}
                <NavDropdown noCaret title={langIcon}>
                  <MenuItem className="animated flipInX" event key={2.1} onClick={(e) => {
                    e.preventDefault();
                    this.props.changeToEnglish()
                  }}>English</MenuItem>
                  <MenuItem className="animated flipInX" event key={2.2} onClick={(e) => {
                    e.preventDefault();
                    this.props.changeToChinese()
                  }}>中文</MenuItem>
                </NavDropdown>
                { /* END Language Menu */}
                <li>
                  <a href="#" data-search-open="">
                    <em className="icon-magnifier"></em>
                  </a>
                </li>
                { /* End Search icon */ }
                { /* START Alert menu */}
                <NavDropdown noCaret eventKey={3} title={ddAlertTitle} id="basic-nav-dropdown" >
                  { /*}<MenuItem onClick={ () => { this.context.router.push('/dashboard')} } className="animated flipInX" eventKey={3.3}><Translate value="dashboard" /></MenuItem>
                  <MenuItem divider /> */ }
                  <MenuItem onClick={this.logOut.bind(this)} className="animated flipInX" eventKey={3.3}><Translate value="logout" /></MenuItem>
                  <MenuItem onClick={this.openEditPassword} className="animated flipInX" eventKey={3.3}><Translate value="edit_password" /></MenuItem>
                </NavDropdown>
                { /* END Alert menu */}
                { /* START Offsidebar button
                <li>
                    <a href="#" data-toggle-state="offsidebar-open" data-no-persist="true">
                        <em className="icon-notebook"></em>
                    </a>
                </li>
                 END Offsidebar menu */ }
              </ul>
              { /* END Right Navbar */}
            </div>
            { /* END Nav wrapper */}
            { /* START Search form
            <form role="search" action="search.html" className="navbar-form">
              <div className="form-group has-feedback">
                <input type="text" placeholder="Type and hit enter ..." className="form-control" />
                <div data-search-dismiss="" className="fa fa-times form-control-feedback"></div>
              </div>
              <button type="submit" className="hidden btn btn-default"><Translate value="submit" /></button>
            </form>
             END Search form */ }
          </nav>
        { /* END Top Navbar */}
        <Modals />

        <SkyLightStateless dialogStyles={refreshDialogueStyle} isVisible={this.state.confirmRefreshOpen} onCloseClicked={() => { this.pageRefreshClose(); }} title={refresh_system}>
          <div>
            <Row className="centerStyle" style={{ marginTop: '20px' }}>
              <h4><Translate value="confirm_refresh" /></h4>
            </Row>
            <Row className="centerStyle">
              <Button
                bsStyle="danger"
                onClick={() => { this.pageRefreshClose(); }}
              >
                <Translate value="cancel" />
              </Button>
              <span>&nbsp;&nbsp;&nbsp;</span>
              <Button
                bsStyle="success"
                onClick={() => { this.pageRefreshConfirm(); }}
              >
                <Translate value="confirm" />
              </Button>
            </Row>
          </div>
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.editPasswordOpen}
          title={changePassword}>
          <UserPassword userDetail={this.props.auth} isMainUser={true}/>
          {/* userDetail passing here sseems like no need really  */}
        </SkyLightStateless>
      </header>
    );
  }
}

const mapState = (state) => {
  // const userPermissioins = localStorage.getItem('userPermissions');
  const userId = localStorage.getItem('BaseUser_id');
  let userDetail = { 'BaseUser_id': userId };
  
  // const filteredCompanySelection = state.header.companies.filter(({ permission_name }) => userPermissioins.includes(permission_name))
  // const filteredCompanySelectionABBLE = state.header.companies.filter(() => true);
  let companies = state.header.companies;
  
  const defaultWarehouse = [{ label: "All", value: '0', }];
  if (!isABBLE && !isABCFF) {
    const userPermissioins = localStorage.getItem('userPermissions');
    companies = state.header.companies.filter(({ permission_name }) => userPermissioins.includes(permission_name))
  }
  let companySelection = companies.map(({ Name, id }) => ({
    label: Name,
    value: id,
  }));
  if((isGGI || isGFD) && isAllCompaniesWhiteList(window.location.href)) {
    companySelection = defaultWarehouse.concat(companySelection)
  }
  let warehouseSelection = state.header.warehouses.map(({ Name, id, IsDefault, Company_id_id }) => ({
    label: Name,
    value: id,
    isDefault: IsDefault,
    companyId: Company_id_id,
  }));
  
  if (warehouseSelection.length && !isABBLE) {
    const companySelectionIds = companySelection.map(({ value }) => value);
    warehouseSelection = warehouseSelection.filter(({ companyId }) => {
      if (!companySelectionIds.find(e => e === companyId)) {
        return false;
      } else {
        return true;
      }
    });
    if (!isHO && !isSH && !isJRC) {
      if ((state.header.warehouses.length === warehouseSelection.length && !isGGI) || (isGGI && !isProductPage(window.location.href) && warehouseSelection[0] && warehouseSelection[0].value != 0)) {
        warehouseSelection = defaultWarehouse.concat(warehouseSelection)
      }  
    }
  } else {
    if (!isHO && !isSH && !isJRC) {
      if (warehouseSelection.length) {
        warehouseSelection = defaultWarehouse.concat(warehouseSelection)
      } 
    }
  }

  if (isGFD) {
    warehouseSelection = warehouseSelection.filter(w => w.value !== '0');
  }
  
  return {
    userDetail,
    companySelection,
    selectedCompany: state.header.selectedCompany,
    warehouseSelection,
    selectedWarehouse: state.header.selectedWarehouse,
  }
}

export default connect(mapState, {
  signoutUser,
  changeToEnglish,
  changeToChinese,
  getCompanies,
  setSelectedCompany,
  setSelectedWarehouse,
})(Header);



// WEBPACK FOOTER //
// ./master/jsx/components/Layout/Header.jsx